import { Routes } from '@angular/router';

export const testsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/tests/tests.component').then(c => c.TestsComponent),
    data: { pageTitle: 'PAGES.TESTS.TITLE', pageType: 'list' }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-test/add-edit-test.component').then(c => c.AddEditTestComponent),
    data: { pageTitle: 'PAGES.TESTS.ADD', pageType: 'add' }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-test/add-edit-test.component').then(c => c.AddEditTestComponent),
    data: { pageTitle: 'PAGES.TESTS.EDIT', pageType: 'edit' }
  },
  {
    path: 'view/:id',
    loadComponent: () => import('./pages/test/test.component').then(c => c.TestComponent),
    data: { pageTitle: 'PAGES.TESTS.DETAILS', pageType: 'details' }
  }
];
